import { useState, useEffect } from "react";
import { secondsToHHMMSS } from "../../utilities/Custom";
import { heroImgURL } from "../../config/Constants";
import emptyItem from "../../../assets/images/emptyItem.png";
import { useInitData } from "../../../apis/hooks";

const MatchSummary = ({ match }) => {
  const [dPlyrs, setDPlyrs] = useState([]);
  const [rPlyrs, setRPlyrs] = useState([]);
  const [heroes, setHeroes] = useState([]);
  const [items, setItems] = useState([]);
  const matchDuration = secondsToHHMMSS(match.duration);

  const [heroesData, itemsData] = useInitData();

  useEffect(() => {
    if (heroesData && itemsData) {
      setHeroes(heroesData.data.allHeroes);
      setItems(itemsData.data.allItems);
    }
  }, [heroesData, itemsData]);

  useEffect(() => {
    const scrollLeft = (evt) => {
      evt.preventDefault();
      scrollContainer.scrollLeft += evt.deltaY;
    };
    const scrollContainer = document.querySelector(".bnchmrk-stats-div");
    scrollContainer.addEventListener("wheel", scrollLeft);
    return () => {
      scrollContainer.removeEventListener("wheel", scrollLeft);
    };
  }, []);

  useEffect(() => {
    setRPlyrs(match.players.filter((player) => player.isRadiant === true));
    setDPlyrs(match.players.filter((player) => player.isRadiant === false));
  }, [match]);

  const plyrList = (player, index) => {
    return (
      <div className="plyr-info" key={index}>
        <div className="heroIcon">
          <img
            className="mtch-sumry-icon"
            src={heroImgURL + heroes[player.hero_id].img}
            alt={player.hero_id}
          />
        </div>
        <div className="plyr-dtls">
          <div className="plyr-name">
            {player.personaname ? player.personaname : "Anonymous"}
          </div>
          <div className="hero-details">
            <span className="hero-lvl">{player.level}</span>
            <span className="hero-name-small">
              {heroes[player.hero_id].localized_name}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const bnchStats = (items) => (player, index, array) => {
    const itemKeys = Object.keys(items);
    let ntrlItem = [];
    let plyrItems = [];
    let backpackItems = [];
    itemKeys.forEach((key, index) => {
      if (
        items[key].id === player.item_0 ||
        items[key].id === player.item_1 ||
        items[key].id === player.item_2 ||
        items[key].id === player.item_3 ||
        items[key].id === player.item_4 ||
        items[key].id === player.item_5
      ) {
        plyrItems = [...plyrItems, items[key]];
      }
      if (items[key].id === player.item_neutral) {
        ntrlItem = items[key];
      }
      if (
        items[key].id === player.backpack_0 ||
        items[key].id === player.backpack_1 ||
        items[key].id === player.backpack_2
      ) {
        backpackItems = [...backpackItems, items[key]];
      }
    });
    let itmsLnth = plyrItems.length;
    let bpItmsLnth = backpackItems.length;
    for (let index = itmsLnth; index < 6; index++) {
      plyrItems = [...plyrItems, { id: 99999 }];
    }
    for (let index = bpItmsLnth; index < 3; index++) {
      backpackItems = [...backpackItems, { id: 99999 }];
    }
    return (
      <tr key={index}>
        <td>
          {typeof player.account_id === "undefined" ? "-" : player.account_id}
        </td>
        <td>{player.kills}</td>
        <td>{player.deaths}</td>
        <td>{player.assists}</td>
        <td>{player.kda}</td>
        <td>
          {player.net_worth === null ? "-" : player.net_worth.toLocaleString()}
        </td>
        <td className="plyr-Itms">
          {plyrItems.map((item, index) => (
            <img
              className="plyr-itm-icn"
              src={item.id === 99999 ? emptyItem : heroImgURL + item.img}
              alt={item.id}
              key={index}
            />
          ))}
        </td>
        <td className="ntrl-Itms">
          {backpackItems.map((item, index) => (
            <img
              className="plyr-itm-icn"
              src={item.id === 99999 ? emptyItem : heroImgURL + item.img}
              alt={item.id}
              key={index}
            />
          ))}
        </td>
        <td>
          <img
            className="plyr-itm-icn"
            src={heroImgURL + ntrlItem.img}
            alt={ntrlItem.id}
          />
        </td>
        <td>
          {player.last_hits} / {player.denies}
        </td>
        <td>{player.hero_damage}</td>
        <td>{player.tower_damage}</td>
        <td>{player.gold_per_min}</td>
        <td>{player.xp_per_min}</td>
        <td>{player.benchmarks.kills_per_min.raw.toFixed(2)}</td>
      </tr>
    );
  };

  const TeamBnchStatsHead = () => {
    return (
      <tr>
        <th style={{ width: "120px" }}>FRIEND ID</th>
        <th style={{ width: "45px" }}>K</th>
        <th style={{ width: "45px" }}>D</th>
        <th style={{ width: "45px" }}>A</th>
        <th style={{ width: "60px" }}>KDA</th>
        <th style={{ width: "85px" }}>NET</th>
        <th style={{ width: "300px" }}>ITEMS</th>
        <th style={{ width: "150px" }}>BACKPACK</th>
        <th style={{ width: "45px" }}></th>
        <th style={{ width: "85px" }}>LH / DN</th>
        <th style={{ width: "130px" }}>HERO DAMAGE</th>
        <th style={{ width: "140px" }}>TOWER DAMAGE</th>
        <th style={{ width: "60px" }}>GPM</th>
        <th style={{ width: "60px" }}>XPM</th>
        <th style={{ width: "60px" }}>KPM</th>
      </tr>
    );
  };
  const dTeamPlyrs = dPlyrs.map(plyrList);
  const rTeamPlyrs = rPlyrs.map(plyrList);
  const dTeamBnchStatsBdy = dPlyrs.map(bnchStats(items));
  const rTeamBnchStatsBdy = rPlyrs.map(bnchStats(items));

  return (
    <div>
      <div className="d-flex w-100">
        <div className="mtch-id">Match Id {match.match_id}</div>
        <div className="score-lbl-txt">
          <div className="score-value">{match.radiant_score}</div>
          <div className="duration-div">
            <div className="lbl-light">DURATION</div>
            <div className="duration-value">{matchDuration}</div>
          </div>
          <div className="score-value">{match.dire_score}</div>
        </div>
        <div className="mtch-vctry-lbl">
          <span className="vctry-lbl">
            {match.radiant_win === true ? "RADIANT" : "DIRE"} VICTORY
          </span>
        </div>
      </div>

      <div className="players-summary">
        <div className="col-xs">
          <div className="team-group">
            <div className="group-lbl-txt">
              <div className="team-lbl-txt radiant-theme">The Radiant</div>
            </div>
            {rTeamPlyrs}
          </div>
          <div className="team-group">
            <div className="group-lbl-txt">
              <div className="team-lbl-txt dire-theme">The Dire</div>
            </div>
            {dTeamPlyrs}
          </div>
        </div>
        <div className="col bnchmrk-stats-div">
          <table className="table bnchmrk-stats fontCdtBlue">
            <thead>
              <TeamBnchStatsHead />
            </thead>
            <tbody>{rTeamBnchStatsBdy}</tbody>
          </table>
          <table className="table bnchmrk-stats fontCdtBlue">
            <thead>
              <TeamBnchStatsHead />
            </thead>
            <tbody>{dTeamBnchStatsBdy}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MatchSummary;
